import React, { createContext, useContext, useMemo, useState, type ReactNode } from 'react'

/** Keep in sync with `WelcomeSidebarChrome` rail width */
export const WELCOME_SIDEBAR_EXPANDED_W = 220
export const WELCOME_SIDEBAR_COLLAPSED_W = 56

type Ctx = {
	/** Pixels reserved before "Home" so it does not sit under the fixed Menu control (not full sidebar width). */
	slotWidthPx: number
	setSlotWidthPx: (n: number) => void
}

const WelcomeSidebarSlotContext = createContext<Ctx | null>(null)

export function WelcomeSidebarSlotProvider({ children }: { children: ReactNode }) {
	const [slotWidthPx, setSlotWidthPx] = useState(0)
	const value = useMemo(() => ({ slotWidthPx, setSlotWidthPx }), [slotWidthPx])
	return (
		<WelcomeSidebarSlotContext.Provider value={value}>{children}</WelcomeSidebarSlotContext.Provider>
	)
}

export function useWelcomeSidebarSlotSafe() {
	return useContext(WelcomeSidebarSlotContext)
}
